import React, { Component } from "react";
import { Link, Route, useRouteMatch } from "react-router-dom";

import { Tabs, Tab, Accordion, AccordionItem, Button } from "carbon-components-react";
import ArrowRight16 from "@carbon/icons-react/lib/arrow--right/16";
import JSCrud from "../../helpers/jsonschemaform/JSCrud";
import { ListUsers } from "./ListUsers";
import { WorkSite } from "./WorkSite";
import { ActivityLog } from "./ActivityLog";
import { KpiNotApplicable } from "./KpiNotApplicable";
import { KpiManualInput } from "./KpiManualInput";
import { IsEnabled } from "../../helpers/authorization/Policies";
import { AppContext } from "../../helpers/context/AppContext";
import PageBreadCrumb from "../../helpers/PageBreadCrumb";
import DeletedAudit from "./DeletedAudit";
import EnergyEmissionJSCrud from "./EnergyEmissionJSCrud";
import { BarrierKPI } from "./BarrierKPI"; //RITM1230723
import { Authorization } from '../../helpers/authorization/Authorization'; //RITM1236093
import { DistributionListHCAlevel } from "./DistributionListHCAlevel"; //RITM1216061 BO DL HCAlevel

function RenderList(props) {
	const tabsArray = ["#global", "#report", "#incident", "#audit", "#inspection", "#emergencydrill", "#training", "#Kpi", "#hoc"];

	const selectTab = (index) => {
		const tag = tabsArray[index] || "";
		props.onChangeTab(tag);
	};

	const selectedIndex = tabsArray.indexOf(props.selectedTab) > -1 ? tabsArray.indexOf(props.selectedTab) : 0;

	return (
		<>
			<PageBreadCrumb linkTo="/" linkText="Home" titleLeft="BackOffice" />
			<div className="mainContainer">
				<div className="bx--grid content full-width">
					<div className=" bx--row ">
						<div className="bx--col-lg-12 bx--tab-container">
							<Tabs selected={selectedIndex} onSelectionChange={(index) => selectTab(index)} tabContentClassName="tab-content">
								<Tab disabled={false} label="Global">
									<div className="some-content">
										<Accordion className="padding-left-right-accordion">
											<AccordionItem className=" " title="Common" open>
												<div className="bx--grid">
													<div className="bx--row ">
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/division" className="bx--underline-none">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	{/* RITM0945977 */}
																	{/* Division */}
																	Business Line
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/subdivision">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	{/* RITM0945977 */}
																	{/* Sub Division */}
																	Sub-Business Line
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/country">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Country
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/customer">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Client
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/nationality">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Nationality
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/contracttype">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Contract Type
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/companytype">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Company Type
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/company">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Company
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/activity">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Activity
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/measureunit" className="bx--underline-none">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Measure Unit
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/project" className="bx--underline-none">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Project
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/worksitegroup" className="bx--underline-none">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	WorkSite Group
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/worksite" className="bx--underline-none">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	WorkSite
																</Button>
															</Link>
														</div>
														{/* <div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/distributionlist" className="bx--underline-none">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Distribution List
																</Button>
															</Link>
														</div> */}
													{/*RITM1216061 BO DL HCAlevel */}
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/distributionlist" className="bx--underline-none">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Distribution List
																</Button>
															</Link>
														</div>
														{/*end*/}
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/consolidatedproject">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Consolidated Project
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/subcontractor">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Sub Contractor
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/purchaseorder">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Purchase Order
																</Button>
															</Link>
														</div>
														{/* RITM0945943 */}
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/usermessage">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	User Message
																</Button>
															</Link>
														</div>
														{/* RITM1037347 */}
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/reasontoreopen">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Reason to Reopen
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/reopenfeatureAllowed">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Reopen feature setting
																</Button>
															</Link>
														</div>
														{/* End */}
														{/* RITM1197573 */}
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/infooriginator">
																<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	Employer Type
																</Button>
															</Link>
														</div>
														{/* End */}
														{/* RITM1243695 */}
														<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/customurl">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Url Customization
																	</Button>
																</Link>
															</div>
														{/* End */}
														{/*
                                                        < div className="bx--col-lg-3 bx--col-md-4">
                                                            <Link to={`/backoffice/lightcondition`}>
                                                                <Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">Light Condition</Button>
                                                            </Link>
                                                        </div>
                                                        <div className="bx--col-lg-3 bx--col-md-4">
                                                            <Link to={`/backoffice/seacondition`}>
                                                                <Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">Sea Condition</Button>
                                                            </Link>
                                                        </div>
                                                        <div className="bx--col-lg-3 bx--col-md-4">
                                                            <Link to={`/backoffice/weathercondition`}>
                                                                <Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">Weather Condition</Button>
                                                            </Link>
                                                        </div>
                                                        */}
													</div>
												</div>
											</AccordionItem>
											<AccordionItem className=" " title="Users" open>
												<div className="bx--grid--full-width">
													<div className="bx--row bx--padding-right-accordion paddingTopRow">
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/listusers">
																<Button className="bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	{" "}
																	User List
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/activitylog">
																<Button className="bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	{" "}
																	Activity Log
																</Button>
															</Link>
														</div>
														<div className="bx--col-lg-3 bx--col-md-4">
															<Link to="/backoffice/employer">
																<Button className=" bx--col-max   bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																	{" "}
																	Employer List
																</Button>
															</Link>
														</div>
													</div>
												</div>
											</AccordionItem>
										</Accordion>
									</div>
								</Tab>
								{IsEnabled(props.user, "Report") ? (
									<Tab disabled={false} label="Report">
										<div className="some-content">
											<Accordion className="padding-left-right-accordion">
												<AccordionItem className=" " title="Energy" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/energysourcetype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Energy Source Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/energyusagetype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Energy Usage Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/energyemittedsubstance">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Energy Emitted Substance
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/energyemission">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Energy Emission
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/energyemissionlocationbased">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Energy Emission Location Based
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/energyemissionmarketbased">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Energy Emission Market Based
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
												<AccordionItem className=" " title="Water" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/waterusagetypegroup">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Water Usage Type Group
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/waterusagetype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Water Usage Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/waterdischargetype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Water Discharge Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/waterdischargetreatment">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Water Discharge Treatment
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/watersourcetype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Water Source Type
																	</Button>
																</Link>
															</div>
															{/* DEV 295 */}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/watersupply">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Water Supply
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/watertreatments">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Water Treatments
																	</Button>
																</Link>
															</div>
															{/* FINE DEV 295 */}
														</div>
													</div>
												</AccordionItem>
												<AccordionItem className=" " title="Waste" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/wastetype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Waste Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/wastetreatment">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Waste Treatment
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/wastedisposal">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Waste Disposal
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
												<AccordionItem className=" " title="Spill" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/spilldestination">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Spill Destination
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/spillvaluerange">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Spill Value Range
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
												{/* RITM1230723 */}
												<AccordionItem className=" " title="Safety" open>
													<div className="bx--grid">
															<div className="bx--row ">
																<div className="bx--col-lg-3 bx--col-md-4">
																	<Link to="/backoffice/barrierkpi">
																		<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																			Barrier KPI
																		</Button>
																	</Link>
																</div>
															</div>
													</div>
												</AccordionItem>
												{/* End */}
											</Accordion>
										</div>
									</Tab>
								) : null}
								{IsEnabled(props.user, "Incident") ? (
									<Tab disabled={false} label="Incident">
										<div className="some-content">
											<Accordion className="padding-left-right-accordion">
												<AccordionItem className=" " title="Incident" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/shiftduration">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Shift Duration
																	</Button>
																</Link>
															</div>
															{/*<div className="bx--col-lg-3 bx--col-md-4">
                                                        <Link to={`/backoffice/severity`}>
                                                            <Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">Severity</Button>
                                                        </Link>
                                                    </div>
                                                    
                                                    <div className="bx--col-lg-3 bx--col-md-4">
                                                        <Link to={`/backoffice/consequence`}>
                                                            <Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">Consequence</Button>
                                                        </Link>
                                                    </div>
                                                    <div className="bx--col-lg-3 bx--col-md-4">
                                                        <Link to={`/backoffice/investigation`}>
                                                            <Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">Investigation</Button>
                                                        </Link>
                                                    </div>*/}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/levelobject">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Level Object
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/leveltitle">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Level Title
																	</Button>
																</Link>
															</div>

															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/injuryclass">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Injury Class
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/injurysource">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Injury Source
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/injurytypetypology">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Injury Type Typology
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/injurytype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Injury Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/equipment">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Equipment
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/jobposition">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Job Position
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/bodypart">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Body Part
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/assettype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Asset Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/assetdamage">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Asset Damage
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/assetdamagetype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Asset Damage Type
																	</Button>
																</Link>
															</div>

															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/place">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Place
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/spilllocation">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Spill Location
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/accidentsource">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Accident Source
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/probability">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Probability
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/workarea">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		WorkArea
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/workprocess">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		WorkProcess
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/lifesavingrulecategory">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Life Saving Rule Category
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/lifesavingrule">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Life Saving Rule
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/rootcause">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Root Cause
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/rootcausedetail">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Root Cause Detail
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/rootcausesubdetail">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Root Cause Sub Detail
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/substancereleased">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Substance Released
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/impacton">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Impact On
																	</Button>
																</Link>
															</div>
															{/* RITM1147493 */}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/incidentbarriergroup">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Barrier Group
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/incidentbarrier">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Barrier
																	</Button>
																</Link>
															</div>
															{/* End */}
															{/* RITM1143712 */}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/typology">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Typology
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
											</Accordion>
										</div>
									</Tab>
								) : null}
								{IsEnabled(props.user, "Audit") ? (
									<Tab disabled={false} label="Audit">
										<div className="some-content">
											<Accordion className="padding-left-right-accordion">
												<AccordionItem className=" " title="Audit" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/auditsection">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit Section
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/auditscope">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit Scope
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/audittype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/audittemplate">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit Template
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/audittemplatesection">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit Template Section
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/auditquestion">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit Question
																	</Button>
																</Link>
															</div>
															{/* <div className="bx--col-lg-3 bx--col-md-4">
                                                        <Link to={`/backoffice/auditanswer`}>
                                                            <Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">Audit Answer</Button>
                                                        </Link>
                                                    </div>
                                                    <div className="bx--col-lg-3 bx--col-md-4">
                                                        <Link to={`/backoffice/auditquestionanswer`}>
                                                            <Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">Audit Question Answer</Button>
                                                        </Link>
                                                    </div> */}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/auditncclassificationtype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit NC Classification Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/auditcarlevel">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit CAR/NC Level
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/auditprocess">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit Process
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/auditfunction">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Audit Subprocess
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/deletedaudit">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Deleted Audit
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/reasonforsampling">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Reason for Sampling
																	</Button>
																</Link>
															</div>
															{/* RITM0946162 */}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/reasonforauditcancellation">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Reason For Audit Cancellation
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
											</Accordion>
										</div>
									</Tab>
								) : null}
								{IsEnabled(props.user, "Inspection") ? (
									<Tab disabled={false} label="Inspection">
										<div className="some-content">
											<Accordion className="padding-left-right-accordion">
												<AccordionItem className=" " title="Common" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/inspectionsection">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Inspection Section
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/inspectiontype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Inspection Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/inspectiontemplate">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Inspection Template
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/inspectiontemplatesection">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Inspection Template Section
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/inspectionquestion">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Inspection Question
																	</Button>
																</Link>
															</div>
															{/* RITM1037347 */}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/reasonforinspectioncancellation">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Reason For Inspection Cancellation
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
											</Accordion>
										</div>
									</Tab>
								) : null}
								{IsEnabled(props.user, "Emergency Drill") ? (
									<Tab disabled={false} label="Emergency Drill">
										<div className="some-content">
											<Accordion className="padding-left-right-accordion">
												<AccordionItem className=" " title="Emergency Drill" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/drilltype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Drill Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/drilltypedetail">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Drill Type Detail
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/drillparticipant">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Drill Participant
																	</Button>
																</Link>
															</div>
															{/*
                                                        <div className="bx--col-lg-3 bx--col-md-4">
                                                            <Link to={`/backoffice/drillemergencylevel`}>
                                                                <Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">Drill Emergency Level</Button>
                                                            </Link>
                                                        </div>
                                                        */}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/drillfrequency">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Drill Frequency
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/drillunitsinvolved">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Drill Units Involved
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/drillquestion">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Drill Question
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/drillchecklisttemplate">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Drill Template
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
											</Accordion>
										</div>
									</Tab>
								) : null}
								{IsEnabled(props.user, "Training") ? (
									<Tab disabled={false} label="Training">
										<div className="some-content">
											<Accordion className="padding-left-right-accordion">
												<AccordionItem className=" " title="Common" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/trainingdata">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		HSE Training Data
																	</Button>
																</Link>
															</div>
															{/*RITM0984969*/}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/LIHStrainingdata">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		LiHs Training Data
																	</Button>
																</Link>
															</div>
															{/*RITM0984969*/}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/traininglocation">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Location
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/trainingcountry">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Country
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/traininglanguage">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Language
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/trainingmethod">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Method
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/trainingassessmentmethod">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Assessment Method
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/trainingcenter">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Training Center
																	</Button>
																</Link>
															</div>
															{/*RITM0984969*/}
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/trainingreportingdate">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Cut off reporting date
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
											</Accordion>
										</div>
									</Tab>
								) : null}
								{IsEnabled(props.user, "Insight Data") ? (
									<Tab disabled={false} label="Kpi">
										<div className="some-content">
											<Accordion className="padding-left-right-accordion">
												<AccordionItem className=" " title="HSE" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/pillarweight" className="bx--underline-none">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Pillar Weights
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/kpiweight">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		KPI Weights
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/kpiinterval">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		{/* RITM0945977 */}
																		{/* KPI Division Intervals */}
																		KPI Business Line Intervals
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/kpigroupinterval">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		KPI Group Intervals
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/kpimanualinput">
																	<Button className="bx--col-max bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		KPI Manual Input
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
											</Accordion>
										</div>
										<div className="some-content">
											<Accordion className="padding-left-right-accordion">
												<AccordionItem className=" " title="Asset Integrity" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/pillaraiweight" className="bx--underline-none">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Pillar Weights
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/kpiaiweight">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		KPI Weights
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/kpiIdleasset">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Asset in Idle
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/kpinotapplicable">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		KPI Not Applicable
																	</Button>
																</Link>
															</div>
															{/*<div className="bx--col-lg-3 bx--col-md-4">
                                <Link to="/backoffice/kpinotapplicables">
                                  <Button
                                    className=" bx--col-max  bx--margin-right"
                                    size="default"
                                    renderIcon={ArrowRight16}
                                    kind="tertiary"
                                  >
                                    KPI Not Applicable
                                  </Button>
                                </Link>
                              </div> */}
															{/* <div className="bx--col-lg-3 bx--col-md-4">
                              <Link to="/backoffice/kpiai">
                                <Button
                                  className=" bx--col-max  bx--margin-right"
                                  size="default"
                                  renderIcon={ArrowRight16}
                                  kind="tertiary"
                                >
                                  KPI
                                </Button>
                              </Link>
                            </div>
                            <div className="bx--col-lg-3 bx--col-md-4">
                              <Link to="/backoffice/pillarai">
                                <Button
                                  className=" bx--col-max  bx--margin-right"
                                  size="default"
                                  renderIcon={ArrowRight16}
                                  kind="tertiary"
                                >
                                  Pillars
                                </Button> 
                              </Link>
                            </div> */}
														</div>
													</div>
												</AccordionItem>
											</Accordion>
										</div>
									</Tab>
								) : null}
								{IsEnabled(props.user, "Incident") ? (
									<Tab disabled={false} label="HOC">
										<div className="some-content">
											<Accordion className="padding-left-right-accordion">
												<AccordionItem className=" " title="HOC" open>
													<div className="bx--grid">
														<div className="bx--row ">
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/hoctype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Hoc Type
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/hocpriority">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Hoc Priority
																	</Button>
																</Link>
															</div>
															<div className="bx--col-lg-3 bx--col-md-4">
																<Link to="/backoffice/hazardtype">
																	<Button className=" bx--col-max  bx--margin-right" size="default" renderIcon={ArrowRight16} kind="tertiary">
																		Hazard Type
																	</Button>
																</Link>
															</div>
														</div>
													</div>
												</AccordionItem>
											</Accordion>
										</div>
									</Tab>
								) : null}
							</Tabs>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default class BackOffice extends Component {
	constructor(props) {
		super(props);

		this.handleChangeTab = this.handleChangeTab.bind(this);

		// this.state = {
		//     selectedTab: 0,
		// };

		// selected={this.props.selectedTab} onSelectionChange={(index) => this.props.setIndex(index)}
	}

	handleChangeTab = (tag) => {
		// tag == #nometab
		this.props.history.push(`/backoffice${tag}`);
	};

	render() {
		const selectedTab = this.props.location.hash || "";
		return (
			<AppContext.Consumer>
				{({ user }) => (
					<>
						<div>
							<Route
								path="/backoffice"
								render={({ match: { url } }) => (
									<>
										<Route exact path={`${url}/`} component={() => <RenderList user={user} onChangeTab={this.handleChangeTab} selectedTab={selectedTab} />} />
										<Route exact path={`${url}/listusers`} component={ListUsers} />
										<Route exact path={`${url}/${process.env.REACT_APP_USER_LIST_AM}`} component={Authorization(user, ListUsers, 'UserList', null, true)} /> {/* RITM0587358 RITM1236093*/} 
										<Route exact path={`${url}/activitylog`} component={ActivityLog} />
										<Route exact path={`${url}/worksite`} component={WorkSite} />
										{/* RITM1230723 */}
										<Route exact path={`${url}/barrierkpi`} component={BarrierKPI} />
										{/* End */}
										{/* RITM1216061 BO DL HCAlevel  */}
										<Route exact path={`${url}/distributionlist`} component={DistributionListHCAlevel} />
										{/* End */}
										 {/* <Route
											exact
											path={`${url}/distributionlist`}
											component={() => (
												<JSCrud
													title="Distribution Lists"
													entity="distributionlist"
													tab="#global"
													headers={[
														//RITM0945977
														// { key: "division", header: "Division" },
														{ key: "divisionName", header: "Business Line" }, // RITM1216061
														//{ key: "division", header: "Business Line" },
														{ key: "recipientType", header: "Recipient Type" },
														{ key: "emailAddress", header: "Email Address" },
														{ key: "distributionListType", header: "Type" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													nullableEnumProperty={["idInvestigation"]}
												/>
											)}
										/>									 */}
											<Route
											exact
											path={`${url}/division`}
											component={() => (
												<JSCrud
													//RITM0945977
													// title="Division"
													title="Business Line"
													entity="division"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "group", header: "Group" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													nullableEnumProperty={["idGroup"]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/subdivision`}
											component={() => (
												<JSCrud
													//RITM0945977
													// title="Sub Division"
													title="Sub-Business Line"
													entity="subdivision"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														//RITM0945977
														// { key: "divisionCode", header: "Division" },
														{ key: "divisionCode", header: "Business Line" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													uiSchema={{ id: { "ui:widget": "hidden" } }}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/country`}
											component={() => (
												<JSCrud
													title="Country"
													entity="country"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/kpiinterval`}
											component={() => (
												<JSCrud
													title="KPI Interval"
													entity="kpiinterval"
													tab="#Kpi"
													headers={[
														{ key: "code", header: "Kpi Code" },
														{ key: "kpi", header: "Kpi" },
														//RITM0945977
														// { key: "division", header: "Division" },
														{ key: "division", header: "Business Line" },
														{ key: "year", header: "Year" },
														{ key: "min", header: "Min" },
														{ key: "max", header: "Max" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/kpigroupinterval`}
											component={() => (
												<JSCrud
													title="KPI Group Interval"
													entity="kpigroupinterval"
													tab="#Kpi"
													headers={[
														{ key: "code", header: "Kpi Code" },
														{ key: "kpi", header: "Kpi" },
														{ key: "year", header: "Year" },
														{ key: "min", header: "Min" },
														{ key: "max", header: "Max" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/pillarweight`}
											component={() => (
												<JSCrud
													title="Pillar Weights"
													entity="pillarweight"
													tab="#Kpi"
													headers={[
														{ key: "pillar", header: "Pillar" },
														{ key: "weight", header: "Weight (%)" },
														{ key: "year", header: "Year" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/pillaraiweight`}
											component={() => (
												<JSCrud
													title="Pillar AI Weights"
													entity="pillaraiweight"
													tab="#Kpi"
													headers={[
														{ key: "pillar", header: "Pillar" },
														{ key: "weight", header: "Weight (%)" },
														{ key: "year", header: "Year" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/kpiweight`}
											component={() => (
												<JSCrud
													title="KPI Weights"
													entity="kpiweight"
													tab="#Kpi"
													headers={[
														{ key: "code", header: "Kpi Code" },
														{ key: "kpi", header: "Kpi" },
														{ key: "weight", header: "Weight (%)" },
														{ key: "year", header: "Year" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/kpiaiweight`}
											component={() => (
												<JSCrud
													title="KPI AI Weights"
													entity="kpiaiweight"
													tab="#Kpi"
													headers={[
														{ key: "code", header: "Kpi Code" },
														{ key: "kpi", header: "Kpi" },
														{ key: "weight", header: "Weight (%)" },
														{ key: "year", header: "Year" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/kpiai`}
											component={() => (
												<JSCrud
													title="KPI"
													entity="kpiai"
													tab="#Kpi"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "pillar", header: "Pillar" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/pillarai`}
											component={() => (
												<JSCrud
													title="Pillar"
													entity="pillarai"
													tab="#Kpi"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/kpiidleasset`}
											component={() => (
												<JSCrud
													title="Asset in idle"
													entity="kpiidleasset"
													tab="#Kpi"
													headers={[
														{ key: "workSite", header: "WorkSite" },
														{ key: "year", header: "Year" },
														{ key: "quarter", header: "Quarter" },
													]}
												/>
											)}
										/>
										<Route exact path={`${url}/kpinotapplicables`} component={KpiNotApplicable} />
										<Route
											exact
											path={`${url}/kpinotapplicable`}
											component={() => (
												<JSCrud
													title="KPI Not Applicable"
													entity="kpinotapplicable"
													tab="#Kpi"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "workSite", header: "WorkSite" },
														{ key: "year", header: "Year" },
														{ key: "quarter", header: "Quarter" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/customer`}
											component={() => (
												<JSCrud
													title="Client"
													entity="customer"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "isJointVenture", header: "Is Joint Venture", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/employer`}
											component={() => (
												<JSCrud
													title="Employers"
													entity="employer"
													tab="#global"
													isReadOnly
													headers={[
														{ key: "name", header: "Name" },
														{ key: "surname", header: "Surname" },
														{ key: "email", header: "Email" },
														{ key: "isActive", header: "Is Active", type: "bool" },
													]}
													uiSchema={{
														id: { "ui:widget": "hidden" },
														deleted: { "ui:widget": "hidden" },
													}}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/nationality`}
											component={() => (
												<JSCrud
													title="Nationality"
													entity="nationality"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "specifyOther", header: "Specify Other", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/contracttype`}
											component={() => (
												<JSCrud
													title="Contract Type"
													entity="contracttype"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/companytype`}
											component={() => (
												<JSCrud
													title="Company Type"
													entity="companytype"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/company`}
											component={() => (
												<JSCrud
													title="Company"
													entity="company"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "sapCode", header: "Company Sap Code" },
														{ key: "companyType", header: "Company Type" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/shiftduration`}
											component={() => (
												<JSCrud
													title="Shift Duration"
													entity="shiftduration"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "daysNumber", header: "Days Number" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/subcontractor`}
											component={() => (
												<JSCrud
													title="Sub Contractor"
													entity="subcontractor"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "infoOriginatorName", header: "Info Originator" },
														{ key: "inUse", header: "In Use", type: "bool" },
														{ key: "isSAP", header: "Is SAP", type: "bool"}
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/purchaseorder`}
											component={() => (
												<JSCrud
													title="Purchase Order"
													entity="purchaseorder"
													tab="#global"
													isReadOnly={true}
													headers={[
														{ key: "number", header: "Number" },
														{ key: "object", header: "Object" },
														{ key: "revision", header: "Revision" },
														{ key: "subContractorName", header: "Sub Contractor" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* RITM0945943 */}
										<Route
											exact
											path={`${url}/UserMessage`}
											component={() => (
												<JSCrud
													title="User Message"
													entity="usermessage"
													tab="#global"
													headers={[
														{ key: "message", header: "Message" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* End */}
										{/* RITM1197573 */}
										<Route
											exact
											path={`${url}/infooriginator`}
											component={() => (
												<JSCrud
													title="Employer Type"
													entity="infooriginator"
													tab="#global"
													headers={[
														{ key: "name", header: "Name" },
														{ key: "employerTypeIRIS", header: "Employer Type" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* End */}
										{/* RITM1243695 */}
										<Route
											exact
											path={`${url}/customurl`}
											component={() => (
												<JSCrud
													title="Url Customization"
													entity="customurl"
													tab="#global"
													headers={[
														{ key: "code", header: "Code"  },
														{ key: "url", header: "Url" },
														{ key: "description", header: "Description" },
													]}
													uiSchema={{
														id: { "ui:widget": "hidden" },
														code: {  "ui:readonly": true },														
													}}
												/>
											)}
										/>
										{/* end */}
										{/*
                            <Route exact path={`${url}/lightcondition`} component={() =>
                                <JSCrud
                                    title="Light Condition"
                                    entity="lightcondition"
                                    tab="#global"
                                    headers={[
                                        { key: 'name', header: 'Name' }
                                    ]}
                                />} />
                            <Route exact path={`${url}/seacondition`} component={() =>
                                <JSCrud
                                    title="Sea Condition"
                                    entity="seacondition"
                                    tab="#global"
                                    headers={[
                                        { key: 'name', header: 'Name' }
                                    ]}
                                />} />
                            <Route exact path={`${url}/weathercondition`} component={() =>
                                <JSCrud
                                    title="Weather Condition"
                                    entity="weathercondition"
                                    tab="#global"
                                    headers={[
                                        { key: 'name', header: 'Name' }
                                    ]}
                                />} />
                            */}
										<Route
											exact
											path={`${url}/severity`}
											component={() => (
												<JSCrud
													title="Severity"
													entity="severity"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "backgroundColor", header: "Background Color", type: "color" },
														{ key: "revision", header: "Revision" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/consequence`}
											component={() => (
												<JSCrud
													title="Consequence"
													entity="consequence"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "outcomeDescription", header: "Description", type: "html" },
														{ key: "eventSubType", header: "EventSubType" },
														{ key: "severity", header: "Severity" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													uiSchema={{
														id: { "ui:widget": "hidden" },
														outcomeDescription: {
															"ui:field": "rte",
															updateOnBlur: true,
															rte: {
																format: "html",
															},
														},
														notes: { "ui:widget": "textarea" },
													}}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/investigation`}
											component={() => (
												<JSCrud
													title="Investigation"
													entity="investigation"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "backgroundColor", header: "Background Color", type: "color" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/levelobject`}
											component={() => (
												<JSCrud
													title="Level Object"
													entity="levelobject"
													tab="#incident"
													headers={[
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/leveltitle`}
											component={() => (
												<JSCrud
													title="Level Title"
													entity="leveltitle"
													tab="#incident"
													headers={[
														{ key: "title", header: "Title" },
														{ key: "depthLevel", header: "Depth Level" },
														{ key: "levelObject", header: "Level Object" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/consolidatedproject`}
											component={() => (
												<JSCrud
													title="Consolidated Project"
													entity="consolidatedproject"
													tab="#global"
													isReadOnly
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/injuryclass`}
											component={() => (
												<JSCrud
													title="Injury Class"
													entity="injuryclass"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "specifyOther", header: "Specify Other", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/injurysource`}
											component={() => (
												<JSCrud
													title="Injury Source"
													entity="injurysource"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "specifyOther", header: "Specify Other", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/injurytypetypology`}
											component={() => (
												<JSCrud
													title="Injury Type Typology"
													entity="injurytypetypology"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/injurytype`}
											component={() => (
												<JSCrud
													title="Injury Type"
													entity="injurytype"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "typology", header: "Typology" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/equipment`}
											component={() => (
												<JSCrud
													title="Equipment"
													entity="equipment"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "specifyOther", header: "Specify Other", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													isRecursive
													uiSchema={{
														id: { "ui:widget": "hidden" },
														idParent: { "ui:widget": "hidden", "ui:readonly": true },
														depthLevel: { "ui:widget": "hidden", "ui:readonly": true },
													}}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/jobposition`}
											component={() => (
												<JSCrud
													title="Job Position"
													entity="jobposition"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "specifyOther", header: "Specify Other", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													isRecursive
													uiSchema={{
														id: { "ui:widget": "hidden" },
														idParent: { "ui:widget": "hidden", "ui:readonly": true },
														depthLevel: { "ui:widget": "hidden", "ui:readonly": true },
													}}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/activity`}
											component={() => (
												<JSCrud
													title="Activity"
													entity="activity"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														//RITM0945977
														// { key: "divisionCode", header: "Division" },
														{ key: "divisionCode", header: "Business Line" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													uiSchema={{ id: { "ui:widget": "hidden" } }}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/hoctype`}
											component={() => (
												<JSCrud
													title="Hoc Type"
													entity="hoctype"
													tab="#hoc"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/hocpriority`}
											component={() => (
												<JSCrud
													title="Hoc Priority"
													entity="hocpriority"
													tab="#hoc"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/hazardtype`}
											component={() => (
												<JSCrud
													title="Hazard Type"
													entity="hazardtype"
													tab="#hoc"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/bodypart`}
											component={() => (
												<JSCrud
													title="Body Part"
													entity="bodypart"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "specifyOther", header: "Specify Other", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/assettype`}
											component={() => (
												<JSCrud
													title="Asset Type"
													entity="assettype"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/place`}
											component={() => (
												<JSCrud
													title="Place"
													entity="place"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/spilllocation`}
											component={() => (
												<JSCrud
													title="Spill Location"
													entity="spilllocation"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "usedForNearMiss", header: "Used For Near Miss", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/accidentsource`}
											component={() => (
												<JSCrud
													title="Accident Source"
													entity="accidentsource"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/probability`}
											component={() => (
												<JSCrud
													title="Probability"
													entity="probability"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/workarea`}
											component={() => (
												<JSCrud
													title="WorkArea"
													entity="workarea"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "specifyOther", header: "Specify Other", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													isRecursive
													uiSchema={{
														id: { "ui:widget": "hidden" },
														idParent: { "ui:widget": "hidden", "ui:readonly": true },
														depthLevel: { "ui:widget": "hidden", "ui:readonly": true },
													}}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/workprocess`}
											component={() => (
												<JSCrud
													title="WorkProcess"
													entity="workprocess"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "specifyOther", header: "Specify Other", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													isRecursive
													uiSchema={{
														id: { "ui:widget": "hidden" },
														idParent: { "ui:widget": "hidden", "ui:readonly": true },
														depthLevel: { "ui:widget": "hidden", "ui:readonly": true },
													}}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/lifesavingrulecategory`}
											component={() => (
												<JSCrud
													title="Life Saving Rule Category"
													entity="lifesavingrulecategory"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/*RITM0615447_LifeSavingRules*/}
										<Route
											exact
											path={`${url}/lifesavingrule`}
											component={() => (
												<JSCrud
													title="Life Saving Rule"
													entity="lifesavingrule"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "category", header: "Category" },
														{ key: "isExclusive", header: "Is Exclusive", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/rootcause`}
											component={() => (
												<JSCrud
													title="Root Cause"
													entity="rootcause"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "idCauseType", header: "Type" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/rootcausedetail`}
											component={() => (
												<JSCrud
													title="Root Cause Detail"
													entity="rootcausedetail"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "rootCause", header: "Root Cause" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/rootcausesubdetail`}
											component={() => (
												<JSCrud
													title="Root Cause Sub Detail"
													entity="rootcausesubdetail"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "rootCauseDetail", header: "Root Cause Detail" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/energysourcetype`}
											component={() => (
												<JSCrud
													title="Energy Source Type"
													entity="energysourcetype"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "measureUnit", header: "Measure Unit" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/measureunit`}
											component={() => (
												<JSCrud
													title="Measure Unit"
													entity="measureunit"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/project`}
											component={() => (
												<JSCrud
													title="Project"
													entity="project"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "customer", header: "Client" },
														{ key: "country", header: "Country" },
														{ key: "consolidatedProject", header: "Consolidated Project" },

														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													nullableEnumProperty={["idCompany", "idConsolidatedProject"]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/worksitegroup`}
											component={() => (
												<JSCrud
													title="WorkSite Group"
													entity="worksitegroup"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/energyusagetype`}
											component={() => (
												<JSCrud
													title="Energy Usage Type"
													entity="energyusagetype"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/waterusagetypegroup`}
											component={() => (
												<JSCrud
													title="Water Usage Type Group"
													entity="waterusagetypegroup"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/watersourcetype`}
											component={() => (
												<JSCrud
													title="Water Source Type"
													entity="watersourcetype"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* DEV 295 */}
										<Route
											exact
											path={`${url}/watersupply`}
											component={() => (
												<JSCrud
													title="Water Supply"
													entity="watersupply"
													tab="#report"
													headers={[
														{ key: "year", header: "Year" },
														{ key: "coefficient", header: "Coefficient" },
														{ key: "waterSourceType", header: "Water Source Type" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/watertreatments`}
											component={() => (
												<JSCrud
													title="WaterTreatments"
													entity="watertreatments"
													tab="#report"
													headers={[
														{ key: "coefficient", header: "Coefficient" },
														{ key: "waterDischargeTreatment", header: "Water Discharge Treatment" },
														{ key: "waterDischargeType", header: "Water Discharge Type" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* FINE DEV 295 */}
										<Route
											exact
											path={`${url}/waterusagetype`}
											component={() => (
												<JSCrud
													title="Water Usage Type"
													entity="waterusagetype"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/waterdischargetype`}
											component={() => (
												<JSCrud
													title="Water Discharge Type"
													entity="waterdischargetype"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/waterdischargetreatment`}
											component={() => (
												<JSCrud
													title="Water Discharge Treatment"
													entity="waterdischargetreatment"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/wastetype`}
											component={() => (
												<JSCrud
													title="Waste Type"
													entity="wastetype"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/wastetreatment`}
											component={() => (
												<JSCrud
													title="Waste Treatment"
													entity="wastetreatment"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* DEV 295 */}
										<Route
											exact
											path={`${url}/wastedisposal`}
											component={() => (
												<JSCrud
													title="Waste Disposal"
													entity="wastedisposal"
													tab="#report"
													headers={[
														{ key: "coefficient", header: "Coefficient" },
														{ key: "wasteTreatment", header: "Waste Treatment" },
														{ key: "wasteType", header: "Waste Type" },
														{ key: "year", header: "Year" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* FINE DEV 295 */}
										<Route
											exact
											path={`${url}/energyemittedsubstance`}
											component={() => (
												<JSCrud
													title="Energy Emitted Substance"
													entity="energyemittedsubstance"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/energyemission`}
											component={() => (
												<EnergyEmissionJSCrud
													title="Energy Emission"
													entity="energyemission"
													tab="#report"
													headers={[
														{ key: "coefficient", header: "Coefficient" },
														{ key: "energyEmittedSubstance", header: "EnergyEmittedSubstance" },
														{ key: "energySourceType", header: "EnergySourceType" },
														{ key: "energyUsageType", header: "EnergyUsageType" },
														{ key: "year", header: "Year" },
														{ key: "outOfScope", header: "Out of Scope", type:  "bool"},
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{ /* RITM0565431_DEV295 */ }
										<Route
											exact
											path={`${url}/energyemissionlocationbased`}
											component={() => (
												<JSCrud
													title="Energy Emission Location Based"
													entity="energyemissionlocationbased"
													tab="#report"
													headers={[
														{ key: "country", header: "Country" },
														{ key: "year", header: "Year" },
														{ key: "ghgEmission", header: "GHG Emission" },
														{ key: "energyEmittedSubstance", header: "Energy Emitted Substance" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/energyemissionmarketbased`}
											component={() => (
												<JSCrud
													title="Energy Emission Market Based"
													entity="energyemissionmarketbased"
													tab="#report"
													headers={[
														{ key: "workSite", header: "WorkSite" },
														{ key: "year", header: "Year" },
														{ key: "inUse", header: "In Use", type: "bool" },
														{ key: "electricityEF", header: "Electricity EF" },
														{ key: "heatingEF", header: "Heating EF" }
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/spilldestination`}
											component={() => (
												<JSCrud
													title="Spill Destination"
													entity="spilldestination"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "idSpillType", header: "Spill Type" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/spillvaluerange`}
											component={() => (
												<JSCrud
													title="Spill Value Range"
													entity="spillvaluerange"
													tab="#report"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "idSpillType", header: "Spill Type" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/auditsection`}
											component={() => (
												<JSCrud
													title="Audit Section"
													entity="auditsection"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "signature", header: "Signature" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/auditscope`}
											component={() => (
												<JSCrud
													title="Audit Scope"
													entity="auditscope"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "sectionName", header: "Section" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/audittype`}
											component={() => (
												<JSCrud
													title="Audit Type"
													entity="audittype"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "section", header: "Section" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/audittemplate`}
											component={() => (
												<JSCrud
													title="Audit Template"
													entity="audittemplate"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "scopeName", header: "Scope" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/audittemplatesection`}
											component={() => (
												<JSCrud
													title="Audit Template Section"
													entity="audittemplatesection"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
														{ key: "sectionName", header: "Template" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/assetdamage`}
											component={() => (
												<JSCrud
													title="Asset Damage"
													entity="assetdamage"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "assetType", header: "Asset Type" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/assetdamagetype`}
											component={() => (
												<JSCrud
													title="Asset Damage Type"
													entity="assetdamagetype"
													tab="#incident"
													headers={[
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/auditquestion`}
											component={() => (
												<JSCrud
													title="Audit Question"
													entity="auditquestion"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "sectionName", header: "TemplateSection" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* <Route exact path={`${url}/auditanswer`} component={() =>
                                <JSCrud
                                    title="Audit Answer"
                                    entity="auditanswer"
                                    headers={[
                                        { key: 'code', header: 'Code' },
                                        { key: 'name', header: 'Name' },
                                        { key: 'inUse', header: 'In Use', 'type': 'bool' },
                                    ]}
                                />} />
                            <Route exact path={`${url}/auditquestionanswer`} component={() =>
                                <JSCrud
                                    title="Audit Question Answer"
                                    entity="auditquestionanswer"
                                    headers={[
                                        { key: 'code', header: 'Code' },
                                        { key: 'name', header: 'Name' },
                                        { key: 'inUse', header: 'In Use', 'type': 'bool' },
                                    ]}
                                />} /> */}
										<Route
											exact
											path={`${url}/auditncclassificationtype`}
											component={() => (
												<JSCrud
													title="Audit NC Classification Type"
													entity="auditncclassificationtype"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "section", header: "Section" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
													isRecursive
													uiSchema={{
														id: { "ui:widget": "hidden" },
														idParent: { "ui:widget": "hidden", "ui:readonly": true },
													}}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/auditcarlevel`}
											component={() => (
												<JSCrud
													title="Audit CAR/NC Level"
													entity="AuditCARLevel"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/auditprocess`}
											component={() => (
												<JSCrud
													title="Audit Process"
													entity="AuditProcess"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "description", header: "Description" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/auditfunction`}
											component={() => (
												<JSCrud
													title="Audit Subprocess"
													entity="AuditFunction"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "description", header: "Description" },
														{ key: "inUse", header: "In Use", type: "bool" },
														{ key: "auditProcessName", header: "Process" },

													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/inspectiontype`}
											component={() => (
												<JSCrud
													title="Inspection Type"
													entity="inspectiontype"
													tab="#inspection"
													uniqueItems
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "section", header: "Section" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/inspectionsection`}
											component={() => (
												<JSCrud
													title="Inspection Section"
													entity="inspectionsection"
													tab="#inspection"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/drilltype`}
											component={() => (
												<JSCrud
													title="Drill Type"
													entity="drilltype"
													tab="#emergencydrill"
													headers={[
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/drilltypedetail`}
											component={() => (
												<JSCrud
													title="Drill Type Detail"
													entity="drilltypedetail"
													tab="#emergencydrill"
													headers={[
														{ key: "name", header: "Name" },
														{ key: "drillTypeName", header: "Drill Type" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/drillparticipant`}
											component={() => (
												<JSCrud
													title="Drill Participant"
													entity="drillparticipant"
													tab="#emergencydrill"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/drillemergencylevel`}
											component={() => (
												<JSCrud
													title="Drill Emergency Level"
													entity="drillemergencylevel"
													tab="#emergencydrill"
													headers={[
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/drillfrequency`}
											component={() => (
												<JSCrud
													title="Drill Frequency"
													entity="drillfrequency"
													tab="#emergencydrill"
													headers={[
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/drillunitsinvolved`}
											component={() => (
												<JSCrud
													title="Drill Units Involved"
													entity="drillunitsinvolved"
													tab="#emergencydrill"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/drillquestion`}
											component={() => (
												<JSCrud
													title="Drill Question"
													entity="drillquestion"
													tab="#emergencydrill"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
														{ key: "drillCheckListTemplateName", header: "Template Name" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/drillchecklisttemplate`}
											component={() => (
												<JSCrud
													title="Drill Template"
													entity="drillchecklisttemplate"
													tab="#emergencydrill"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "description", header: "Description"},
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/inspectiontemplate`}
											component={() => (
												<JSCrud
													title="Inspection Template"
													entity="inspectiontemplate"
													tab="#inspection"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "typeName", header: "Type" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/inspectiontemplatesection`}
											component={() => (
												<JSCrud
													title="Inspection  Template Section"
													entity="inspectiontemplatesection"
													tab="#inspection"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "templateName", header: "Template" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/inspectionquestion`}
											component={() => (
												<JSCrud
													title="Inspection  Question"
													entity="inspectionquestion"
													tab="#inspection"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "templateSectionName", header: "Template Section" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/trainingdata`}
											component={() => (
												<JSCrud
													/*title="Training Data"*/
													title="HSE Training Data" /*RITM0984969*/
													entity="trainingdata"
													tab="#training"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "title", header: "Title" },
														{ key: "courseCode", header: "Course Code" },
														{ key: "peopleLearnigCode", header: "MyLearning Code" }, 
														//{ key: "duration", header: "Standard Duration (Hours)" },/*RITM0984969*/
														{ key: "minDuration", header: "Minimum Duration (Hours)" },/*RITM0984969*/
														{ key: "maxDuration", header: "Maximum Duration (Hours)" },/*RITM0984969*/
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/LIHStrainingdata`}
											component={() => (
												<JSCrud
													title="LiHS Training Data" /*RITM0984969*/
													entity="LIHSTrainingData"
													tab="#training"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "title", header: "Title" },
														{ key: "courseCode", header: "Course Code" },
														{ key: "peopleLearnigCode", header: "MyLearning Code" },
														{ key: "minDuration", header: "Minimum Duration (Hours)" },
														{ key: "maxDuration", header: "Maximum Duration (Hours)" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/trainingcountry`}
											component={() => (
												<JSCrud
													title="Country"
													entity="trainingcountry"
													tab="#training"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/trainingassessmentmethod`}
											component={() => (
												<JSCrud
													title="Assessment Method"
													entity="trainingassessmentmethod"
													tab="#training"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/traininglanguage`}
											component={() => (
												<JSCrud
													title="Language"
													entity="traininglanguage"
													tab="#training"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/traininglocation`}
											component={() => (
												<JSCrud
													title="Location"
													entity="traininglocation"
													tab="#training"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/trainingmethod`}
											component={() => (
												<JSCrud
													title="Method"
													entity="trainingmethod"
													tab="#training"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										<Route
											exact
											path={`${url}/trainingcenter`}
											component={() => (
												<JSCrud
													title="Center"
													entity="trainingcenter"
													tab="#training"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* RITM0984969 */}
										<Route
											exact
											path={`${url}/trainingreportingdate`}
											component={() => (
												<JSCrud
													title="Training Reporting Date"
													entity="trainingreportingdate"
													tab="#training"
													headers={[
														{ key: "reportingEndDate", header: "Cut off of Training End Date", type: 'date' },
														{ key: "year", header: "Year" },
													]}
												/>
											)}
										/>
										<Route exact path={`${url}/kpimanualinput`} component={KpiManualInput} />
										<Route exact path={`${url}/deletedaudit`} component={DeletedAudit} />
										<Route
											exact
											path={`${url}/reasonforsampling`}
											component={() => (
												<JSCrud
													title="Reason for Sampling"
													entity="reasonforsampling"
													tab="#reasonforsampling"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "description", header: "Description" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>

										{/* RITM0946162 */}
										<Route
											exact
											path={`${url}/reasonforauditcancellation`}
											component={() => (
												<JSCrud
													title="Reason For Audit Cancellation"
													entity="reasonforauditcancellation"
													tab="#audit"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* RITM1037347 */}
										<Route
											exact
											//path={`${url}/reasontoreopen`}
											path={`${url}/reasontoreopen`}
											component={() => (
												<JSCrud
													title="Reasons to Reopen"
													entity="reasontoreopen"
													tab="#global"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "module", header: "Module" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/reopenfeatureallowed`}
											component={() => (
												<JSCrud
													title="Reopen Feature Allowed "
													entity="reopenfeatureallowed"
													tab="#global"
													headers={[
														{ key: "module", header: "Module" },
														{ key: "referenceYear", header: "Reference Year", type: "int" },
													]}
												/> 
											)}
										/>							
										<Route
											exact
											path={`${url}/reasonforinspectioncancellation`}
											component={() => (
												<JSCrud
													title="Reason For Inspection Cancellation"
													entity="reasonforinspectioncancellation"
													tab="#inspection"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										
										{/* RITM1037347 */}

										<Route
											exact
											path={`${url}/substancereleased`}
											component={() => (
												<JSCrud
													title="Substance Released"
													entity="SubstanceReleased"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/impacton`}
											component={() => (
												<JSCrud
													title="Impact On"
													entity="ImpactOn"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* RITM1143712 */}
										<Route
											exact
											path={`${url}/typology`}
											component={() => (
												<JSCrud
													title="Typology"
													entity="Typology"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "specifyOther", header: "Specify Other", type: "bool" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* RITM1147493 */}
										<Route
											exact
											path={`${url}/incidentbarriergroup`}
											component={() => (
												<JSCrud
													title="Barrier Group"
													entity="IncidentBarrierGroup"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										<Route
											exact
											path={`${url}/incidentbarrier`}
											component={() => (
												<JSCrud
													title="Barrier"
													entity="IncidentBarrier"
													tab="#incident"
													headers={[
														{ key: "code", header: "Code" },
														{ key: "name", header: "Name" },
														{ key: "ranking", header: "Ranking" },
														{ key: "incidentBarrierGroupName", header: "Barrier Group" },
														{ key: "inUse", header: "In Use", type: "bool" },
													]}
												/>
											)}
										/>
										{/* End */}
									</>
								)}
							/>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}
